import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { faWarning, faClose } from '@fortawesome/free-solid-svg-icons';

import './index.scss';
import Button from '../button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  translatedMessage: string;
  confirmKey: string;
  onConfirm: () => void;
  onCancel: () => void;
  containerClass?: string;
};

function ConfirmationModal({ translatedMessage, confirmKey, onConfirm, onCancel, containerClass }: Props) {
  const { t } = useTranslation();
  const container = containerClass ? document.getElementsByClassName(containerClass)[0] || document.body : document.body;

  const escListener = (event: KeyboardEvent) => {
    event.keyCode === 27 && onCancel();
  };

  useEffect(() => {
    window.addEventListener('keyup', escListener);
    return () => {
      window.removeEventListener('keyup', escListener);
    };
  });

  return (
    container && (
      <React.Fragment>
        {ReactDOM.createPortal(
          <div className="confirmation-modal">
            <div className="confirmation-modal__backdrop" onClick={onCancel}></div>
            <div className="confirmation-modal__content-area">
              <div className="confirmation-modal__header">
                <div className="confirmation-modal__header-title">
                  <FontAwesomeIcon className="confirmation-modal__warning-icon" icon={faWarning} />
                  <div className="text-large--semi-bold">{t('deleteDiagnosis')}</div>
                </div>
                <FontAwesomeIcon className="confirmation-modal__close-icon" icon={faClose} onClick={onCancel} />
              </div>
              <div className="confirmation-modal__body">
                <p className="text-small--regular">{translatedMessage}</p>
              </div>
              <div className="confirmation-modal__footer">
                <Button className="confirmation-modal__cancel-btn text-medium--bold" onClick={onCancel}>
                  {t('cancel')}
                </Button>
                <Button className="confirmation-modal__confirm-btn text-medium--bold" onClick={onConfirm}>
                  {t(confirmKey)}
                </Button>
              </div>
            </div>
          </div>,
          container,
        )}
      </React.Fragment>
    )
  );
}

export default ConfirmationModal;
